import axios from "axios";
import { api } from "./api_route";

export const createFinalAwardsAPI = async (finalAwardsData) => {
  try {
    const config = {};
    if (
      typeof FormData !== "undefined" &&
      finalAwardsData instanceof FormData
    ) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.post(
      `${api}/finalAwards/create`,
      finalAwardsData,
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const getFinalAwardsByCaseIDAPI = async (caseID) => {
  try {
    const response = await axios.get(`${api}/finalAwards/case/${caseID}`);
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const updateFinalAwardsAPI = async (finalAwards_ID, finalAwardsData) => {
  try {
    const config = {};
    if (
      typeof FormData !== "undefined" &&
      finalAwardsData instanceof FormData
    ) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.put(
      `${api}/finalAwards/update/${finalAwards_ID}`,
      finalAwardsData,
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const deleteFinalAwardsAPI = async (finalAwards_ID) => {
  try {
    const response = await axios.delete(
      `${api}/finalAwards/delete/${finalAwards_ID}`,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};
